import userService from './userService';
import { LogAnalysisResult } from '../models/LogAnalysis';

const API_BASE_URL = process.env.REACT_APP_PULSE_API_BASE_URL;

class FetchError extends Error {

}

/**
 * Analyzes CSV log data by sending it to the backend.
 * @param csvData The CSV data as a string.
 * @returns A promise that resolves with the log analysis result.
 */
export const analyzeCsvLog = async (
  apiKey: string | null,
  csvData: string,
): Promise<LogAnalysisResult> => {

  if (!API_BASE_URL) {
    throw new FetchError('API base URL is not configured');
  }

// ToDo: for now we use the generic key
//   if (!apiKey) {
//     throw new FetchError('API key is missing for authenticated user.');
//   }

  apiKey = process.env['REACT_APP_PULSE_API_KEY'] || '';

  const endpoint = `/api/analysis/csvlog`;

  return userService.authenticatedFetch2<LogAnalysisResult>(
    'Analyze CSV Log Data', // purpose
    apiKey,
    endpoint,       // endpoint to call
    {
      method: 'POST',
      headers: { 'Content-Type': 'text/csv' },
      // No query parameters
      body: csvData,
    },
  );
};